import { DateStr } from '@mi-front/core';
import { SelectField } from '@mi-front/ui';
import { Button } from '@mui/material';
import { useField } from 'formik';
import { uniqBy } from 'lodash';
import sortBy from 'lodash/sortBy';
import { FormattedMessage, useIntl } from 'react-intl';
import { apiClient } from '../../../../../../api';

interface Props {
  stationId: string;
}

export const MentionFromSchedulesField = ({ stationId }: Props) => {
  const [, , { setValue }] = useField('source');
  const { $t } = useIntl();

  return (
    <SelectField
      label={$t({
        id: 'audit.liveMentionsAdd.mentionFromSchedules',
        defaultMessage: 'Mención desde schedules',
      })}
      name={'mentionSchedules'}
      options={[] as { name: string; description: string }[]}
      getOptionValue={(m: { name: string; description: string }) => m.name}
      getOptionLabel={(m: { name: string; description: string }) => `${m.name} (${m.description})`}
      loadOptions={async () => {
        return apiClient.audit
          .fetchMentionsDateSchedules({
            stationId,
            filter: {
              date: '2023-04-02' as DateStr,
            },
          })
          .then((r) =>
            r.results.map((r) => ({
              name: r.customId,
              description: r.name,
            })),
          )
          .then((r) => uniqBy(r, 'name'))
          .then((r) => sortBy(r, 'name'));
      }}
      markRequired
      hint={
        <div>
          <Button
            sx={{ marginLeft: -1.25, marginTop: -0.5 }}
            variant="text"
            size="small"
            onClick={() => setValue('custom')}
          >
            <FormattedMessage
              id="audit.liveMentionsAdd.createCustomMention"
              defaultMessage="Crear una mención custom"
            />
          </Button>
        </div>
      }
    />
  );
};
